// extracted by mini-css-extract-plugin
export default {"container":"ValidationItem_container__kQFEz","check":"ValidationItem_check__IxTcQ","text":"ValidationItem_text__sY5Na","text--valid":"ValidationItem_text--valid__9lTyM"};